<button mat-flat-button [type]="type" [ngClass]="[color, active, textPosition, size]" [class.disabled]="disabled" [disabled]="disabled">
  <mat-icon *ngIf="icon">{{icon}}</mat-icon>
  <ng-content></ng-content>
</button>
